import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Col, Space, Checkbox, Flex, Row, Typography, Card, Spin, message } from "antd";
import { CheckCircleOutlined, CheckCircleFilled, SyncOutlined } from "@ant-design/icons";
import FibeLogo from "../../../Assets/paymentIcon/fibe.png";
import FinsallLogo from "../../../Assets/paymentIcon/finsall.png";
import BimaPayLogo from "../../../Assets/paymentIcon/bimapay.png";
import EMi  from "../../../Assets/paymentIcon/EMi.png";
import { UnselectedImageWrapper } from "../style";
import "./style.css";
import { FIBE_INGESTION } from "../../../Services/endpoints";
import { error_message } from "../../../Constant";
import { useIsMobile } from "../../../Hooks";
import { postApi } from "../../../Services/apiService";
import { decrypt, encrypt } from "../../../Services/AESEncryptionDecryption";
import CignaLoader from "../../../UI/CignaLoader";

const FinancingContainer = styled.div`
  padding: ${(props) => (props?.$is_mobile ? "0px" : "0px 40px")};
  width: 100%;
`;

const StyledRadioTab = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px 12px 12px;
  min-width: 140px;
  max-height: 65px;
  min-height: 65px;
  border-radius: 8px;
  border: 1.5px solid ${(props) => (props.checked ? "#7262ca" : "#969696ff")}; /* Blue border when checked */
  background: #ffffff;
  box-shadow: ${(props) =>
    props?.checked ? "0 0 10px 0 rgba(0, 0, 0, 0.2)" : "none"};
  cursor: pointer;
  width: fit-content;
  transition: all 0.3s ease;

  &:hover {
    border-color: ${(props) => (props?.checked ? "#7262ca" : "#a397e6")};
  }
`;

const ModeIcon = styled.img`
  width: ${(props) => props.$w};
  height: ${(props) => props.$h};
  object-fit: contain;
  filter: ${(props) =>
    props.checked ? "none" : "grayscale(100%) opacity(0.7)"};
`;

const spinObject = {
  indicator: {
    color: '#8400ffff',
  },
};

const paymentOptions = [
  { icon: FibeLogo, name: "Fibe", w: "60px", h: "40px" },
  // { icon: FinsallLogo, name: "Finsall", w: "80px", h: "40px" },
  // { icon: BimaPayLogo, name: "BimaPay", w: "80px", h: "40px" },
];
const FinancingSection = ({
  isRedirect = false,
  setIsRedirect = null,
  financingConsent= {consent1: false, consent2:false, consent3: false},
  setFinancingConsent = null,
  ingestionFinancingRequest = null
}) => {
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Fibe"); // State to manage selection
  const handleOptionChange = (selectedTab) => {
    setSelectedOption(selectedTab);
  };

  const redirectToPortal = (url) => {
    setLoading(true);
    setTimeout(() => {
       window.location.assign(url);
       return setLoading(false);
    }, 2000);
  }
  const fibeIngestion = async () => {
    try {
      const encryptedPayload = encrypt(JSON?.stringify(ingestionFinancingRequest));
      let result = await postApi(FIBE_INGESTION, {
        encodedString: encryptedPayload
      });
      result = result.data
      if (result?.response?.status === 200) {
        if (result?.response?.response) {
          const decryptedRes = JSON?.parse(decrypt(result?.response?.response));
          redirectToPortal(decryptedRes?.bitlyUrl);
        }
      }else if (result?.response?.status === 404) {
        message.error(result.error.errorMessage || error_message?.common_error);
      }
      else if (result?.response?.status === 601) {
        message.error( result.response.error.errorMessage ||error_message?.common_error);
      }else if (result?.status === 404) {
        message.error(result.error.errorMessage || error_message?.common_error);
      }else{
        message.error(result?.response?.error?.errorMessage)
      }
    } catch (err) {
      message.error(error_message?.common_error);
    }
  }
  const handleNext = () => {
      switch(selectedOption){
      case "Fibe": 
       return fibeIngestion();
      case "Finsall":
            default:
        window.location.assign("https://portal.fibe.in/SignUp");
        return setLoading(false);
    }
  }
  useEffect(() => {
    if(isRedirect){
      // setLoading(true);
      handleNext();
      if(setIsRedirect){
        setIsRedirect(false);
      }
    }
  }, [isRedirect])
  return (
    <div className={"fixed"} style={{ minHeight: "150px" }}>
      <CignaLoader
        loading={loading}
        fullPage={true}
        loadingMessage={`Redirecting to ${selectedOption} Web Portal...`}
      />
      <Card style={{ minHeight: "140px" }}>
        <FinancingContainer
          $is_mobile={isMobile}
          className="financing-container"
        >
          {/* <div className="payment-type-image-container">
            <div className="payment-type-image-wrapper">
              <UnselectedImageWrapper
                src={EMi}
                style={{
                  width: "40px",
                  height: "40px",
                  position: "static",
                  opacity: "0.08",
                }}
              />
              <label style={{ opacity: "0.08", marginTop: "5px" }}>
                {"Premium Financing"}
              </label>
            </div>
          </div> */}
              <Typography.Title level={5} style={{ paddingBottom: "16px" }}>
                {"Available Payment Options"}
              </Typography.Title>
              <Row gutter={[16, 16]}>
                {paymentOptions?.map((type, i) => {
                  const isChecked = selectedOption === type?.name;
                  return (
                    <Col key={i} xs={24} sm={9} md={7} lg={6} xl={4}>
                      <StyledRadioTab
                        checked={isChecked}
                        onClick={() => handleOptionChange(type?.name)}
                      >
                        <Flex
                          justify="space-between"
                          align="flex-start"
                          style={{ width: "100%" }}
                        >
                          <ModeIcon
                            src={type?.icon}
                            $w={type?.w}
                            $h={type?.h}
                            checked={isChecked}
                            alt={type?.name}
                          />
                          {isChecked ? (
                            <CheckCircleFilled style={{ color: "#52c41a" }} />
                          ) : (
                            <CheckCircleOutlined
                              style={{ color: "#969696ff" }}
                            />
                          )}
                        </Flex>
                      </StyledRadioTab>
                    </Col>
                  );
                })}
              </Row>
          <div style={{ marginTop: "48px", maxWidth: "900px" }}>
            <Space size="middle" align="start">
              <Checkbox
                checked={financingConsent.consent1}
                style={{ marginTop: "2px" }}
                onChange={(event) => {
                  setFinancingConsent({...financingConsent, consent1: event?.target?.checked});
                }}
              />
              <p>
                {`I hereby confirm that I have voluntarily selected premium financing for payment of my insurance premium. I acknowledge and agree that, upon selection of this option, I will be redirected to the website of a third‑party premium financing partner (${selectedOption.toLocaleUpperCase()}), to complete the premium financing process.`}
                <br />
              </p>
            </Space>
            <Space size="middle" align="start">
              <Checkbox
                checked={financingConsent.consent2}
                style={{ marginTop: "2px" }}
                onChange={(event) => {
                  setFinancingConsent({ ...financingConsent, consent2: event?.target?.checked });
                }}
              />
              <p>
                I hereby acknowledge that the website of a third‑party premium
                financing partner (Third‑Party Website) is not owned, operated,
                or controlled by ManipalCigna Health Insurance Company Limited (MCHI),
                I further acknowledge that MCHI does not guarantee, or assume any
                responsibility for the products, services, content, or security of
                such Third‑Party Website. I hereby acknowledge that MCHI shall
                not be held liable for any loss, delay, denial, or dispute arising
                from the premium financing arrangement or the actions of the premium
                financing partner. I understand that my access to and use of the
                Third‑Party Website will be governed by its applicable terms of use
                and privacy policy, which I will be required to review on the Third‑Party Website.
              </p>
            </Space>
            <Space size="middle" align="start">
              <Checkbox
                checked={financingConsent.consent3}
                style={{ marginTop: "2px" }}
                onChange={(event) => {
                  setFinancingConsent({...financingConsent, consent3: event?.target?.checked});
                }}
              />
              <p>
                I hereby expressly consent to the sharing of my personal information
                provided by me to MCHI with its empanelled premium financing partner
                solely for the purpose of facilitating premium financing. Any additional
                information required for such purpose shall be collected and processed
                directly by the premium financing partner in accordance with its applicable
                terms of use and privacy policy. MCHI shall have no control over or
                responsibility for such collection or processing of information by the
                premium financing partner.
              </p>
            </Space>
          </div>
        </FinancingContainer>
      </Card>
    </div>
  );
};

export default FinancingSection;
